import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  List,
  ListItem,
  ListItemContent,
  Chip,
  ColorPaletteProp,
  ListDivider,
  Sheet,
  Table,
  iconButtonClasses,
  Button,
  IconButton,
  Card,
  Input,
  ButtonGroup,
  Dropdown,
  MenuButton,
  Menu,
  MenuItem,
  Modal,
  ModalOverflow,
  ModalDialog,
  ModalClose,
  DialogTitle,
  DialogContent,
  FormControl,
  FormLabel,
  Stack,
  Select,
  Option,
} from "@mui/joy";
import { toast } from "react-toastify";
import { LoadingView, PageTitle, StatusBadge } from "../../../components";

import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

import {
  addMerchantRequest,
  addMerchantReset,
  fetchMerchantReset,
  fetchMerchantRequest,
  getActivePartnersRequest,
  getActivePartnersReset,
} from "../../../store/actions";

import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import {
  FilterAltOutlined,
  PersonAddOutlined,
  RefreshOutlined,
  RemoveRedEyeOutlined,
  WarningRounded,
} from "@mui/icons-material";
import { STATUS } from "../../../constant";
import { NAVIGATE_TO_MERCHANTVIEWPAGE } from "../../../route/types";

const MobileViewTable = ({ data, props }) => {
  return (
    <Box sx={{ display: { xs: "block", md: "none" } }}>
      {data.map((listItem, index) => (
        <List
          key={index}
          size="sm"
          sx={{
            "--ListItem-paddingX": 0,
          }}
        >
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
            }}
          >
            <ListItemContent
              sx={{ display: "flex", gap: 2, alignItems: "start" }}
            >
              <div>
                <Typography fontWeight={600} gutterBottom>
                  {listItem.name}
                </Typography>

                <Typography level="body-xs" gutterBottom>
                  <b>Code:</b> {listItem.code}
                </Typography>

                <Typography level="body-xs" gutterBottom>
                  <b>Email:</b> {listItem.email}
                </Typography>
              </div>
            </ListItemContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-end",
                rowGap: 1,
              }}
            >
              <StatusBadge
                color={
                  {
                    1: "success",
                    2: "warning",
                    3: "neutral",
                    4: "danger",
                  }[listItem.status] as ColorPaletteProp
                }
              >
                {
                  {
                    1: "Active",
                    2: "Inactive",
                    3: "Pending",
                    4: "Rejected",
                  }[listItem.status]
                }
              </StatusBadge>
              <ButtonGroup variant="soft" size="sm">
                <Button color="primary" onClick={() => props.view(listItem)}>
                  <RemoveRedEyeOutlined />
                </Button>
              </ButtonGroup>
            </Box>
          </ListItem>
          <ListDivider />
        </List>
      ))}
    </Box>
  );
};

const DesktopViewTable = ({ data, props }) => {
  return (
    <React.Fragment>
      <Sheet
        className="OrderTableContainer"
        variant="outlined"
        sx={{
          display: { xs: "none", md: "flex", lg: "flex" },
          borderRadius: "sm",
          flexShrink: 1,
          overflow: "auto",
          minHeight: 0,
        }}
      >
        <Table
          aria-labelledby="tableTitle"
          stickyHeader
          hoverRow
          sx={{
            "--TableCell-headBackground":
              "var(--joy-palette-background-level1)",
            "--Table-headerUnderlineThickness": "1px",
            "--TableRow-hoverBackground":
              "var(--joy-palette-background-level1)",
            "--TableCell-paddingY": "4px",
            "--TableCell-paddingX": "8px",
            "& tr > *:last-child": {
              position: "sticky",
              right: 0,
              bgcolor: "var(--TableCell-headBackground)",
            },
          }}
        >
          <thead>
            <tr style={{ textAlign: "center" }}>
              <th style={{ width: 80, padding: "10px 6px" }}>Code</th>
              <th style={{ width: 120, padding: "10px 6px" }}>Name</th>
              <th style={{ width: 140, padding: "10px 6px" }}>Email</th>
              <th style={{ width: 70, padding: "10px 6px" }}>Status</th>
              <th aria-label="last" style={{ width: 100, padding: "10px 6px" }}>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index}>
                <td>
                  <Typography level="body-sm">{row.code}</Typography>
                </td>
                <td>
                  <Typography level="body-sm">{row.name}</Typography>
                </td>
                <td>
                  <Typography level="body-sm">{row.email}</Typography>
                </td>
                <td>
                  <StatusBadge
                    color={
                      {
                        1: "success",
                        2: "warning",
                        3: "neutral",
                        4: "danger",
                      }[row.status] as ColorPaletteProp
                    }
                  >
                    {
                      {
                        1: "Active",
                        2: "Inactive",
                        3: "Pending",
                        4: "Rejected",
                      }[row.status]
                    }
                  </StatusBadge>
                </td>
                <td>
                  <ButtonGroup variant="soft" size="sm">
                    <Button
                      title="View"
                      color="primary"
                      onClick={() => props.view(row)}
                    >
                      <RemoveRedEyeOutlined />
                    </Button>
                  </ButtonGroup>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Sheet>
    </React.Fragment>
  );
};

const MerchantsPage = ({
  loginResult,

  merchantListStatus,
  merchantListResult,
  merchantListErrorMessage,

  addMerchantStatus,
  addMerchantResult,
  addMerchantErrorMessage,

  getActivePartnersStatus,
  getActivePartnersResult,
  getActivePartnersErrorMessage,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isDesktop = useMediaQuery("(min-width:600px)");
  const [merchantData, setMerchantData] = useState([]);

  const [formModal, setFormModal] = useState(false);
  const [createdCode, setCreatedCode] = useState(null);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [account_number, setAccountNumber] = useState("");
  const [fspCode, setFspCode] = useState("");
  const [accountType, setAccountType] = useState("COLLECTION");

  useEffect(() => {
    if (merchantListStatus === STATUS.SUCCESS) {
      setMerchantData(merchantListResult);
    } else if (merchantListStatus === STATUS.ERROR) {
      setMerchantData([]);
      toast.error(merchantListErrorMessage);
      dispatch(fetchMerchantReset());
    }

    if (addMerchantStatus === STATUS.SUCCESS) {
      setCreatedCode(addMerchantResult?.code ?? null);
      setFormModal(false);
      setName("");
      setEmail("");
      setAccountNumber("");
      setFspCode("");
      setAccountType("COLLECTION");
      dispatch(fetchMerchantRequest(loginResult.token));
      dispatch(addMerchantReset());
    } else if (addMerchantStatus === STATUS.ERROR) {
      toast.error(addMerchantErrorMessage);
      dispatch(addMerchantReset());
    }

    if (getActivePartnersStatus === STATUS.ERROR) {
      toast.error(getActivePartnersErrorMessage);
      dispatch(getActivePartnersReset());
    }
  });

  useEffect(() => {
    dispatch(fetchMerchantRequest(loginResult.token));
    dispatch(getActivePartnersRequest(loginResult.token, {}));
  }, []);

  /* -------- FUNCTION TO SEARCH ------ */
  const [search, setSearch] = useState("");
  const [filterBy, setFilterBy] = useState("name");

  const filteredData = merchantData.filter((item) => {
    if (filterBy === "code") {
      return String(item.code).toLowerCase().includes(search.toLowerCase());
    } else if (filterBy === "email") {
      return (item.email || "")
        .toLowerCase()
        .includes(search.toLowerCase());
    } else {
      return (item.name || "")
        .toLowerCase()
        .includes(search.toLowerCase());
    }
  });

  /* ------ pagination functions ------- */
  const [currentPage, setCurrentPage] = useState(0);
  const ITEMS_PER_PAGE = 20;
  const pageLength = Math.ceil(filteredData.length / ITEMS_PER_PAGE);

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(0, prevPage - 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, pageLength - 1));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = filteredData.slice(
    currentPage * ITEMS_PER_PAGE,
    (currentPage + 1) * ITEMS_PER_PAGE,
  );
  /* ---- end of pagination functions ------- */

  /* -------- actions ----------- */

  const goToViewPage = (details) => {
    navigate(NAVIGATE_TO_MERCHANTVIEWPAGE, {
      state: {
        merchant_code: details.code,
      },
    });
  };

  const openAddForm = () => {
    setName("");
    setEmail("");
    setAccountNumber("");
    setFspCode("");
    setAccountType("COLLECTION");
    setFormModal(true);
  };

  const handleFspChange = (event, newValue) => {
    setFspCode(newValue);
  };

  const submitForm = (event) => {
    event.preventDefault();
    if (name && email && account_number && fspCode && accountType) {
      const data = {
        name: name,
        email: email,
        account_number: account_number,
        account_fsp: fspCode,
        account_type: accountType,
      };

      dispatch(addMerchantRequest(loginResult.token, data));
    } else {
      toast.error("Please fill all required information");
    }
  };

  const checkLoading = () => {
    if (
      merchantListStatus === STATUS.LOADING ||
      addMerchantStatus === STATUS.LOADING
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Box>
      <PageTitle title={"Manage Merchants"} />

      <LoadingView loading={checkLoading()} />

      {/* search */}
      <Sheet
        className="SearchAndFilters"
        sx={{
          display: "flex",
          my: 1,
          gap: 1,
          flexDirection: { xs: "column", sm: "row" },
        justifyContent: "space-between",
      }}
    >
      {/* only admin can create merchant */}
      {loginResult.role === 1 && (
        <Button
          startDecorator={<PersonAddOutlined />}
          color="success"
          sx={{ width: "auto" }}
          onClick={openAddForm}
        >
          Add new Merchant
        </Button>
      )}

      {merchantData.length > 0 && (
          <Input
            size="sm"
            placeholder={`Search by ${filterBy}`}
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            startDecorator={<SearchIcon />}
            endDecorator={
              <Dropdown>
                <MenuButton variant="plain">
                  <FilterAltOutlined />
                </MenuButton>
                <Menu sx={{ minWidth: "120px", fontSize: "14px" }}>
                  <MenuItem
                    onClick={() => setFilterBy("name")}
                    selected={filterBy == "name"}
                  >
                    Name
                  </MenuItem>
                  <MenuItem
                    onClick={() => setFilterBy("code")}
                    selected={filterBy == "code"}
                  >
                    Code
                  </MenuItem>
                  <MenuItem
                    onClick={() => setFilterBy("email")}
                    selected={filterBy == "email"}
                  >
                    Email
                  </MenuItem>
                </Menu>
              </Dropdown>
            }
            sx={{
              width: { xs: "auto", md: "30%" },
              textTransform: "capitalize",
            }}
          />
        )}
      </Sheet>

      {merchantData.length > 0 ? (
        <>
          {/* ------ render different view depend on plafform -------- */}
          <MobileViewTable
            data={paginatedData}
            props={{
              view: goToViewPage,
              role: loginResult.role,
            }}
          />
          <DesktopViewTable
            data={paginatedData}
            props={{
              view: goToViewPage,
              role: loginResult.role,
            }}
          />

          {/* Pagination */}
          {merchantData.length > ITEMS_PER_PAGE && (
            <Box
              className="Pagination-laptopUp"
              sx={{
                pt: 2,
                gap: 1,
                [`& .${iconButtonClasses.root}`]: { borderRadius: "50%" },
                display: "flex",
              }}
            >
              <Button
                size="sm"
                variant="outlined"
                color="neutral"
                startDecorator={<KeyboardArrowLeftIcon />}
                onClick={handlePreviousPage}
                disabled={currentPage === 0}
              >
                {isDesktop ? "Previous" : ""}
              </Button>

              <Box sx={{ flex: 1 }} />
              {/* for desktop to display page number */}
              {Array.from({ length: pageLength }).map((_, page) => (
                <IconButton
                  key={page}
                  size="sm"
                  variant={"outlined"}
                  color="neutral"
                  onClick={() => handlePageChange(page)}
                  disabled={currentPage === page}
                  sx={{ display: { xs: "none", md: "flex" } }}
                >
                  {page + 1}
                </IconButton>
              ))}

              {/* for mobile to display page number */}
              <Typography
                level="body-sm"
                mx="auto"
                textAlign={"center"}
                sx={{ display: { xs: "flex", md: "none" } }}
              >
                Page {currentPage + 1} of {pageLength}
              </Typography>
              <Box sx={{ flex: 1 }} />

              <Button
                size="sm"
                variant="outlined"
                color="neutral"
                endDecorator={<KeyboardArrowRightIcon />}
                onClick={handleNextPage}
                disabled={currentPage === pageLength - 1}
              >
                {isDesktop ? "Next" : ""}
              </Button>
            </Box>
          )}
        </>
      ) : (
        <Card
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            top: "20%",
          }}
        >
          <WarningRounded
            sx={{ fontSize: "50px", color: "background.appcolor" }}
          />
          <Typography level="title-md">Resource not Found</Typography>
          <Typography level="body-sm" textAlign={"center"}>
            This can be either no Merchant list available or network issue.
          </Typography>
          <Button
            onClick={() => dispatch(fetchMerchantRequest(loginResult.token))}
            startDecorator={<RefreshOutlined />}
          >
            REFRESH
          </Button>
        </Card>
      )}

      {/* ------ Modal form for create Merchant details ------ */}
      <Modal open={formModal}>
        <ModalOverflow sx={{ pt: "70px" }}>
          <ModalDialog
            aria-labelledby="nested-modal-title"
            aria-describedby="nested-modal-description"
            sx={(theme) => ({
              minWidth: { xs: "unset", md: "600px" },
              [theme.breakpoints.only("xs")]: {
                top: "60px",
                bottom: 0,
                left: 0,
                right: 0,
                borderTopLeftRadius: 20,
                borderTopRightRadius: 20,
                transform: "none",
                maxWidth: "unset",
                overflow: "auto",
              },
            })}
          >
            <ModalClose
              variant="outlined"
              onClick={() => setFormModal(false)}
            />
            <DialogTitle>{"Add Merchant"}</DialogTitle>
            <DialogContent>
              Please enter Merchant details correct. The merchant code will be
              generated automatically.
            </DialogContent>
            <Stack component="form" onSubmit={submitForm} gap={2} sx={{ mt: 2 }}>
              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                {/* name */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Merchant Name</FormLabel>
                  <Input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Enter merchant name"
                  />
                </FormControl>

                {/* email */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Email</FormLabel>
                  <Input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter merchant email"
                  />
                </FormControl>
              </Stack>

              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                {/* account number */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Account Number</FormLabel>
                  <Input
                    type="text"
                    value={account_number}
                    onChange={(e) => setAccountNumber(e.target.value)}
                    placeholder="Enter account number"
                  />
                </FormControl>

                {/* fsp (partner) */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>FSP (Partner)</FormLabel>
                  <Select
                    placeholder="Select partner"
                    value={fspCode}
                    onChange={handleFspChange}
                    required
                  >
                    {(getActivePartnersResult || [])
                      .filter((partner) => partner.fsp_code !== "")
                      .map((partner) => (
                        <Option key={partner.id} value={partner.fsp_code}>
                          {partner.name}
                        </Option>
                      ))}
                  </Select>
                </FormControl>
              </Stack>

              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                {/* account type */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Account Type</FormLabel>
                  <Select
                    value={accountType}
                    onChange={(event, newValue) => setAccountType(newValue)}
                    required
                  >
                    <Option value="COLLECTION">COLLECTION</Option>
                    <Option value="DISBURSEMENT">DISBURSEMENT</Option>
                  </Select>
                </FormControl>
              </Stack>

              <Stack gap={4} sx={{ mt: 2 }}>
                <Button type="submit" fullWidth>
                  Submit
                </Button>
              </Stack>
            </Stack>
          </ModalDialog>
        </ModalOverflow>
      </Modal>

      {/* ------ Success dialog showing generated merchant code ------ */}
      <Modal open={createdCode !== null}>
        <ModalOverflow sx={{ pt: "70px" }}>
          <ModalDialog
            aria-labelledby="merchant-created-title"
            aria-describedby="merchant-created-description"
            sx={(theme) => ({
              minWidth: { xs: "unset", md: "600px" },
              [theme.breakpoints.only("xs")]: {
                top: "60px",
                bottom: 0,
                left: 0,
                right: 0,
                borderTopLeftRadius: 20,
                borderTopRightRadius: 20,
                transform: "none",
                maxWidth: "unset",
                overflow: "auto",
              },
            })}
          >
            <ModalClose
              variant="outlined"
              onClick={() => setCreatedCode(null)}
            />
            <DialogTitle id="merchant-created-title">
              Merchant created successfully
            </DialogTitle>
            <DialogContent id="merchant-created-description">
              The merchant code below is the merchant's login identifier and has
              been emailed to the merchant.
            </DialogContent>
            <Stack gap={3} sx={{ mt: 2, alignItems: "center" }}>
              <Chip
                size="lg"
                color="success"
                variant="soft"
                sx={{ fontSize: "lg", py: 1, px: 2 }}
              >
                Code: {createdCode}
              </Chip>
              <Button fullWidth onClick={() => setCreatedCode(null)}>
                Close
              </Button>
            </Stack>
          </ModalDialog>
        </ModalOverflow>
      </Modal>
    </Box>
  );
};

const mapStateToProps = ({ merchant, partner, auth }) => {
  const { otpResult: loginResult } = auth;
  const {
    merchantListResult,
    merchantListStatus,
    merchantListErrorMessage,

    addMerchantStatus,
    addMerchantResult,
    addMerchantErrorMessage,
  } = merchant;

  const {
    getActivePartnersStatus,
    getActivePartnersResult,
    getActivePartnersErrorMessage,
  } = partner;

  return {
    loginResult,

    merchantListStatus,
    merchantListResult,
    merchantListErrorMessage,

    addMerchantStatus,
    addMerchantResult,
    addMerchantErrorMessage,

    getActivePartnersStatus,
    getActivePartnersResult,
    getActivePartnersErrorMessage,
  };
};

export default connect(mapStateToProps, {})(MerchantsPage);
